export default {"src":"/login-app/[GIT_HASH]/_next/static/media/expand_arrows.7fba036b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};